export default __webpack_public_path__ + "48ea465.png";